var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogVisible,
            width: "40%",
            "modal-append-to-body": "",
            "append-to-body": "",
            "close-on-click-modal": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            closed: _vm.handleClose,
          },
        },
        [
          _c(
            "el-form",
            {
              ref: "form",
              attrs: {
                size: "small",
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "80px",
              },
            },
            [
              _c(
                "el-form-item",
                { attrs: { label: "协议名称", prop: "name" } },
                [
                  _c(
                    "el-select",
                    {
                      staticStyle: { width: "100%", "margin-right": "20px" },
                      attrs: {
                        disabled: _vm.optionType === "view",
                        size: "small",
                        placeholder: "请选择协议名称",
                        clearable: "",
                      },
                      on: { change: _vm.nameChange },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    },
                    _vm._l(_vm.protocolList.value, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.name, value: item.name },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "协议版本", prop: "version" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled: _vm.optionType === "view",
                      size: "small",
                      maxlength: "200",
                      placeholder: "请输入协议版本",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.version,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "version", $$v)
                      },
                      expression: "form.version",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "协议内容", prop: "content" } },
                [
                  _c(
                    "avue-ueditor",
                    _vm._b(
                      {
                        ref: "editor",
                        model: {
                          value: _vm.form.content,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "content", $$v)
                          },
                          expression: "form.content",
                        },
                      },
                      "avue-ueditor",
                      _vm.options,
                      false
                    )
                  ),
                ],
                1
              ),
              _c("el-form-item", [
                _c(
                  "div",
                  { on: { click: _vm.handleContent } },
                  [
                    _c(
                      "UploadBtn",
                      {
                        ref: "uploadBtn",
                        attrs: {
                          size: "small",
                          type: "primary",
                          currentUrl: _vm.form.url,
                          content: _vm.content,
                          title: _vm.form.name,
                          bgColor: _vm.form.backgroundColor,
                        },
                        on: {
                          uploadSuccess: _vm.uploadSuccess,
                          uploadFail: _vm.uploadFail,
                        },
                      },
                      [_vm._v("预览")]
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "背景色", prop: "backgroundColor" } },
                [
                  _c("el-input", {
                    attrs: {
                      size: "small",
                      placeholder: "请输入背景色",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.backgroundColor,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "backgroundColor", $$v)
                      },
                      expression: "form.backgroundColor",
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "协议地址" } }, [
                _c("span", [_vm._v(_vm._s(_vm.form.url))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "说明", prop: "remark" } },
                [
                  _c("el-input", {
                    attrs: {
                      disabled:
                        _vm.optionType === "view" &&
                        _vm.larkApprovalStatus === 1,
                      size: "small",
                      maxlength: "200",
                      placeholder: "请输入说明",
                      clearable: "",
                    },
                    model: {
                      value: _vm.form.remark,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "remark", $$v)
                      },
                      expression: "form.remark",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              !(this.larkApprovalStatus === 1 && this.optionType === "view")
                ? _c(
                    "el-button",
                    {
                      attrs: {
                        size: "small",
                        type: "primary",
                        loading: _vm.loading,
                      },
                      on: { click: _vm.submitForm },
                    },
                    [_vm._v("确 定")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }